module.exports = __webpack_public_path__ + "static/media/politics.6c4baefa.jpg";